function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect, useRef } from "react";
import { Skeleton, message, Space, QRCode, Image } from 'antd';
import Common from "./includes/Common";
import { CheckCircleFill, XCircleFill } from 'react-bootstrap-icons';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";

var PatientQrCodeViewBracelet = function PatientQrCodeViewBracelet(_ref) {
  var pid = _ref.pid;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      customer = _useState2[0],
      setCustomer = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isDataLoading = _useState4[0],
      setIsDataLoading = _useState4[1];

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      dataChanged = _useState6[0],
      setDataChanged = _useState6[1];

  useEffect(function () {
    setIsDataLoading(true);
    setDataChanged(false);
    axios.all([axios.get(Common.baseApiUrl + "getcustomerbyid/" + pid.toString() + "/" + Common.currentUser.id)]).then(function (response) {
      if (response[0].data.status == 200) {
        setCustomer(response[0].data.patient);
      } else {
        message.error({
          content: response[0].data.message,
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: error.toString(),
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [pid, dataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isDataLoading && /*#__PURE__*/_jsx(Skeleton, {
      active: true
    }), customer != null && /*#__PURE__*/_jsx("div", {
      style: {
        padding: "6px 26px",
        textAlign: "center",
        maxWidth: "800px ",
        background: "#FFFFFF",
        borderRadius: "6px"
      },
      children: /*#__PURE__*/_jsxs(Space, {
        direction: "horizontal",
        children: [/*#__PURE__*/_jsx("div", {
          style: {
            marginRight: "45px"
          },
          children: /*#__PURE__*/_jsx(Image, {
            src: "drawables/mvlt.png",
            width: "110px",
            preview: false
          })
        }), /*#__PURE__*/_jsx("div", {
          style: {
            marginRight: "65px"
          },
          children: /*#__PURE__*/_jsx("h5", {
            children: customer.firstname + " " + customer.lastname + " - " + customer.idnumber
          })
        }), /*#__PURE__*/_jsx(QRCode, {
          value: customer.idnumber,
          size: 90
        })]
      })
    })]
  });
};

export default PatientQrCodeViewBracelet;